import * as actions from "./actionTypes/index";

export const MatchOfTheDayGamesListUpdateReceived = (payload, key) => {
    return {
        type: actions.MATCH_OF_THE_DAY_GAMES_LIST_UPDATE_RECEIVED,
        key,
        payload
    };
};

export const ResetMatchOfTheDayGamesList = (key) => {
    return {
        type: actions.RESET_MATCH_OF_THE_DAY_GAMES_LIST,
        key
    };
};